export const UgcComponent = () => null;
